<template>
    <rkm-form
        ref="RkmForm"
    >
        <rkm-alert show color="warning">
            <strong>Atenção:</strong> São permitidos apenas arquivos do tipo PDF, JPEG, JPG e PNG, com no máximo 2mb.
        </rkm-alert>

        <rkm-alert show info v-if="item">
            <strong>Paciente:</strong>

            {{ item.nome }}

            <strong v-if="item.preferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                ({{ item.nomeSocial }})
            </strong> -

            <strong>Prontuário: </strong>{{ item.prontuario }}
        </rkm-alert>

        <rkm-area title="Arquivos">
            <rkm-row class="flex-nowrap">

                <rkm-col class="flex-grow-1">
                    <rkm-form-file
                        @change="validarAnexos"
                        browse-text="Selecionar"
                        label="Arquivo(s)"
                        multiple
                        placeholder="SELECIONE O(S) ARQUIVOS(S)"
                        ref="file-input"
                        type="file"
                        v-model="model.arquivo"
                    >
                        Pesquisar
                    </rkm-form-file>
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        @click.stop="save()"
                        color="primary"
                    >
                        {{ solicitacao.id ? 'Salvar' : 'Incluir' }}
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        @click="resetForm()"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            no-margin-top
            title="Arquivos importados"
        >
            <div>
                <rkm-table
                    :fields="fields.tables.upload"
                    :items="items"
                    hide-filters
                    hide-pagination
                    tag="div"
                >
                    <template v-slot:cell(arquivo)="{ item }" v-if="solicitacao.id">
                        <a href="#" class="link" @click.prevent="$refs.ModalView.open(item)">{{ item.arquivo }}</a>
                    </template>

                    <template v-slot:cell(actions)="{ item }">
                        <rkm-button
                            v-if="solicitacao.id"
                            @click="handleDownload(item)"
                            color="primary"
                            small
                            title="Baixar"
                        >
                            <rkm-icon icon="download" />
                        </rkm-button>

                        <rkm-button
                            :disabled="!!solicitacao.id"
                            @click="handleDestroy(item)"
                            color="danger"
                            small
                            title="Excluir"
                        >
                            <rkm-icon icon="trash" />
                        </rkm-button>
                    </template>
                </rkm-table>

                <ModalView ref="ModalView" />
            </div>
        </rkm-area>
    </rkm-form>
</template>

<script>

//Vuex.
import {mapActions} from 'vuex'

//Components.
import ModalView from './components/Modal'

//Mixins.
import {repository, error, data, object} from '@/mixins'

// Enums.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

export default {
    components: {
        ModalView,
    },
    computed: {
        fields() {

            return {
                tables: {
                    upload: [
                        { key: 'arquivo', label: 'Arquivo', sortable: true },
                        { key: 'data', label: 'Data', sortable: true },
                        { key: 'usuario', label: 'Responsável', sortable: true },
                        { key: 'actions', label: 'Ações', class: 'col-min' },
                    ],
                }
            }
        },
    },
    created() {

        this.repositories = {
            upload: this.getConectaSusRepository('regulacao.upload'),
        }

        this.load()
    },
    data: () => ({
        items: [],
        enums: { preferenciaNome },
        fileSize: true,
        formData: null,
        model: {
           arquivo: null,
        },
        msg: '',
        multiple: false,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            if (this.item && this.solicitacao.id) {

                this.setLoading()

                this.repositories.upload.show({
                    solicitacao_id: this.solicitacao.id,
                })
                .then(({data}) => {

                    this.items = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
            } else if (this.arquivos.length > 0) {

                this.items = this.arquivos
            }
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (!valid) return

                    if (this.handleupload()) {
                        if (this.solicitacao.id) {

                            this.setLoading()

                            this.repositories.upload.store(this.prepareData())
                                .then(response => {
                                    this.items = response.data
                                    this.handleStatus()
                                    this.resetForm()

                                    if (this.msg !== '') {
                                        this.showAlert(`Os seguintes arquivos NÃO foram importados, pois ultrapassam o limite
                                            máximo de 2mb: <strong>${this.msg}</strong>`, "Atenção")
                                    } else {
                                        this.showSaveNotification('Arquivos(s) importado(s) com sucesso!')
                                    }
                                })
                                .catch(this.handleError)
                                .finally(() => this.unsetLoading())
                        } else {

                            const newItems = this.prepareDataForNewSolicitacao();
                            this.items = [...this.items, ...newItems];
                            this.resetForm()

                            if (this.msg !== '') {
                                this.showAlert(`Os seguintes arquivos NÃO foram importados, pois ultrapassam o limite
                                    máximo de 2mb: <strong>${this.msg}</strong>`, "Atenção")
                            }

                            this.$emit('arquivos-preparados', this.items, this.formData);
                        }
                    }
                })
        },
        handleupload() {

            if(!this.model.arquivo || this.model.arquivo && this.model.arquivo.length == 0){

                this.showValidationNotification("É necessário selecionar ao menos um arquivo.")

                return false
            }

            return true
        },
        handleStatus() {

            if (this.items.length > 0) {
                this.item.status = 'ARQUIVO(S) IMPORTADO(S)'
            } else {
                this.item.status = 'ARQUIVO(S) NÃO IMPORTADO(S)'
            }
        },
        prepareData() {
            let arquivo = this.model.arquivo;
            let formData = new FormData();
            this.msg = '';

            formData.append('solicitacao_id', this.solicitacao.id);
            formData.append('multiple', this.multiple);

            arquivo.forEach((element) => {

                if (element.size > 2000000) {

                    this.msg = this.msg ? this.msg.concat(`, ${element.name}`) : this.msg.concat(`${element.name}`);
                } else {

                    formData.append('upload[]', element, element.name);
                }
            });

            return formData;
        },
        prepareDataForNewSolicitacao() {
            let arquivo = this.model.arquivo;
            let formData = this.formData || new FormData();
            this.msg = '';
            let newItems = [];

            arquivo.forEach((element) => {

                if (element.size > 2000000) {

                    this.msg = this.msg ? this.msg.concat(`, ${element.name}`) : this.msg.concat(`${element.name}`);
                } else {

                    formData.append('upload[]', element, element.name);

                    newItems.push({
                        id: Date.now(),
                        arquivo: element.name.toUpperCase(),
                        data: this.additionals.dataAtual,
                        usuario: this.additionals.nomeUsuarioLogado,
                        file: element,
                    });
                }
            });

            this.formData = formData;

            return newItems;
        },
        resetForm() {

            this.model.arquivo = null
        },
        handleDownload(item) {

            this.repositories.upload.download(item.id)
                .then(response => {
                    const nomeArquivo = response.headers['content-disposition']
                        .split('filename=')[1]
                        .replace(/['"]/g, '');

                    const tipoMime = response.headers['content-type'];

                    const blob = new Blob([response.data], { type: tipoMime });

                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = nomeArquivo;

                    link.click();

                    window.URL.revokeObjectURL(link.href);
                })
                .catch(this.handleError);
        },
        handleDestroy(item) {
            if (this.solicitacao.id) {

                const destroy = () => this.repositories.upload.destroy(item.id)
                    .then(() => {
                        const objId = this.items.findIndex((obj => obj.id == item.id));
                        this.items.splice(objId, 1);
                    });

                this.showDeleteConfirmation('Deseja realmente excluir o arquivo?', destroy, this.handleError);
            } else {

                const objId = this.items.findIndex(obj => obj.id == item.id);
                if (objId !== -1) {

                    this.items.splice(objId, 1);
                    const newFormData = new FormData();

                    this.items.forEach(i => {
                        if (i.file instanceof Blob) {
                            newFormData.append('upload[]', i.file, i.arquivo);
                        }
                    });

                    this.formData = newFormData;

                    this.$emit('arquivos-atualizados', this.items, this.formData);
                }
            }
        },
        validarAnexos(event) {

            const files = event.target.files || [];
            const allowedExtensions = [
                'application/pdf',
                'image/jpeg',
                'image/jpg',
                'image/png',
            ];
            const maxFileSize = 2 * 1024 * 1024;
            this.multiple = files.length > 1;

            for (let file of files) {

                if (!allowedExtensions.includes(file.type)) {
                    this.showValidationNotification('Todos os arquivos devem estar no formato PDF, JPEG, JPG ou PNG.');
                    this.resetFileInput(event);
                    return;
                }

                if (file.size > maxFileSize) {
                    this.showValidationNotification('Todos os arquivos devem ter no máximo 2MB.');
                    this.resetFileInput(event);
                    return;
                }
            }

            this.model.arquivo = Array.from(files);
        },
        resetFileInput(event) {

            this.model.arquivo = null;

            if (this.$refs.fileInput && typeof this.$refs.fileInput.reset === 'function') {
                this.$refs.fileInput.reset();
            } else {
                event.target.value = '';
            }
        }
    },
    mixins: [repository, error, data, object],
    props: {
        item: { type: Object, default: null },
        solicitacao: { type: Object, default: null },
        arquivos: { type: Array, default: () => [] },
        additionals: { type: [Array, Object], default: null },
    },
}
</script>

<style scoped>
.link {
    color: black;
    text-decoration: none;
}

.link:hover {
    color: blue;
    outline: none;
}
</style>